<template>
  <div class="ls_spin_container">
    <!-- SOURCE AND TARGET TABLES -->
    <Row :gutter="32" type="flex" justify="space-between">
      <!--SOURCE TABLE-->
      <Col :xs="24" :sm="24" :lg="8" v-if="action === 'create'">
        <!-- SEARCH -->
        <Input
          v-model="kit_composition.search_value"
          suffix="ios-search"
          placeholder="Введите наименование/артикул/код"
          style="width: 100%;"
          class="mb-30"
        />
        <div class="card-container card-container__one-col-table">
          <Table
            class="one-col-table desktop_table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>

          <Table
            v-if="kit_composition.search_value"
            class="one-col-table mobile-table"
            :data="kit_composition.source_table.data"
            :columns="kit_composition.source_table.columns"
            :loading="kit_composition.source_table.loading"
            :show-header="false"
            @on-row-click="addToKitTargetTable"
          ></Table>


          <Button
            class="desktop_table"
            v-show="
              kit_composition.source_table.current_page *
                kit_composition.source_table.limit <
                kit_composition.source_table.total_records
            "
            style="width: 100%"
            type="info"
            @click="kit_composition.source_table.current_page++"
            >Показать еще
          </Button>
        </div>
      </Col>

      <!--TARGET TABLE-->
      <Col :xs="24" :sm="24" :md="24" :lg="16" class="target_table">
        <Form :model="formData" ref="formData" :rules="formDataRules">

          <Row type="flex" align="middle">

            <Col :xs="24" :sm="24" :md="0">
              <!--APPLIED-->
              <FormItem style="display: inline-block">
                <!--            <i-switch v-model="formData.applied" size="large"></i-switch>-->
                <!--            <span style="margin-left: 5px">{{ applied_label }}</span>-->

                <div style="margin-right: 24px"
                >
                  <div class="switch-custom">
                    <i-switch v-model="formData.applied"></i-switch>
                    <span>{{ applied_label }}</span>
                  </div>

                </div>
              </FormItem>
            </Col>

            <Col :xs="24" :sm="24" :md="0">
              <!--ORDER_DATE-->
              <FormItem>
                <!--<template v-slot:label>-->
                <!--<span style="margin-left: 50px">{{-->
                <!--schema.order_date.label-->
                <!--}}</span>-->
                <!--</template>-->

                <DatePicker
                  :clearable="false"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  :value="formData.order_date"
                  @on-change="setOrderDate"
                ></DatePicker>
              </FormItem>
            </Col>

          </Row>




          <h1>
            {{ order_type_labels[formData.type] }} №
            <input class="form__order_number" v-model="formData.number" />
          </h1>

          <Row :gutter="32" style="margin-top: 20px">

            <!--RECIPIENT-->
            <Col :xs="24" :sm="12">
              <FormItem :label="recipient_label" prop="recipient.id" v-if="action==='create'">
                <Select v-model="formData.recipient.id" filterable>
                  <OptionGroup label="Магазины">
                    <Option
                      v-for="item in formSelectOptions.store"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </OptionGroup>
                </Select>
              </FormItem>
              <h2 class="mb-24" v-if="action==='edit'">{{ recipient_label }}: {{ formData.recipient.name }}</h2>
            </Col>
          </Row>
        </Form>

        <div v-if="action === 'create'">
          <Tabs
            style="height: 100%;"
            v-if="kit_composition.target_table.length > 0"
          >
            <TabPane label="Товары">
              <div>
                <!-- TABLE OF SELECTED PRODUCTS-->

                <Row
                  class="desktop_table"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center; color: rgba(77,79,92,0.5); margin-bottom: 15px"
                >
                  <Col span="1">#</Col>
                  <Col span="6" style="text-align: left;">Наименование</Col>
                  <Col span="3">Ед.изм.</Col>
                  <Col span="3">Количество</Col>
                  <Col span="3">Цена</Col>
                  <Col span="3" style="text-align: right;">Всего</Col>
                  <Col span="2"></Col>
                </Row>
                <Divider style="margin: 0 0 10px 0;"></Divider>

                <Row
                  class="desktop_table"
                  v-for="(product, counter) in kit_composition.target_table"
                  :key="product.id"
                  :gutter="10"
                  type="flex"
                  justify="space-between"
                  style="text-align: center;"
                >
                  <Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>
                  <Col span="1">{{ counter + 1 }}</Col>
                  <Col span="6" style="text-align: left;">{{ product.name }}</Col>
                  <Col span="3" style="text-align: center;">{{
                    product.unit ? product.unit : "-"
                  }}</Col>
                  <Col span="3" style="text-align: center;">
                    <InputNumber
                      @input="changeCountTargetTable($event, counter)"
                      :min="1"
                      :value="kit_composition.target_table[counter].count"
                    ></InputNumber>
                  </Col>
                  <Col span="3">
                    <InputNumber
                      @input="changePriceTargetTable($event, counter)"
                      style="width: 100%"
                      :min="1"
                      v-model="kit_composition.target_table[counter].base_price"
                      :formatter="value => formatNumber(value)"
                    ></InputNumber>
                  </Col>
                  <Col span="3" style="text-align: right;"
                  >{{ formatNumber(product.total_price) }} {{ currency }}</Col>
                  <Col span="2" style="text-align: right;">
                    <Button
                      style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                      icon="md-trash"
                      @click="deleteFromKitTargetTable(product.id)"
                    ></Button>
                  </Col>
                </Row>


                <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
                <div class="mobile-table">
                  <div class="card-container"
                       v-for="(product, counter) in kit_composition.target_table"
                       :key="product.id">
                    <div>
                      <h2>{{product.name}}</h2>
                      <p>Ед.изм.: {{product.unit ? product.unit : "-"}}</p>

                      <p>Количество: <InputNumber
                        @input="changeCountTargetTable($event, counter)"
                        :min="1"
                        :value="kit_composition.target_table[counter].count"
                      ></InputNumber>
                      </p>

                      <p>Цена: <InputNumber
                        @input="changePriceTargetTable($event, counter)"
                        style="width: 100%"
                        :min="1"
                        v-model="kit_composition.target_table[counter].base_price"
                        :formatter="value => formatNumber(value)"
                      ></InputNumber>
                      </p>

                      <h2>Всего:
                        {{ formatNumber(product.total_price) }} {{ currency }}
                      </h2>
                    </div>

                    <div>
                      <Button
                        style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                        icon="md-trash"
                        @click="deleteFromKitTargetTable(product.id)"
                      ></Button>
                    </div>
                  </div>
                </div>


                <!-- TOTAL ROWS -->
                <div style="padding-top: 30px">
                  <!--TOTAL SUM-->
                  <Row :gutter="32" class="total_row">
                    <Col span="12">
                      <h3>Всего:</h3>
                    </Col>
                    <Col span="12" style="text-align: right;">
                      <h3>
                        {{ formatNumber(total_sum) }} {{ currency }}
                      </h3>
                    </Col>
                  </Row>
                </div>

                <!-- DESCRIPTION FORM-->
                <Form :model="formData" style="margin-top: 20px; padding: 5px">
                  <!-- DESCRIPTION -->
                  <FormItem>
                    <Input
                      type="textarea"
                      v-model="formData.description"
                      :rows="4"
                      placeholder="Комментарий"
                    />
                  </FormItem>
                </Form>
              </div>
            </TabPane>
          </Tabs>


          <div
            v-else
            class="no-select"
          >
            <span class="desktop_table">
              <Icon type="md-arrow-back" />
              Выберите товары
            </span>

            <span class="mobile-table">

              <Icon type="md-arrow-up" /> <br>
              Выберите товары <br> (введите наименование в строке поиска)
            </span>
          </div>



        </div>
        <div v-if="action === 'edit'">
          <div>
            <!-- TABLE OF PRODUCTS-->
            <Row
              class="desktop_table"
              :gutter="10"
              type="flex"
              justify="space-between"
              style="text-align: center; color: gray"
            >
              <Col class="mb-10" span="1">#</Col>
              <Col class="mb-10" span="6" style="text-align: left;">Наименование</Col>
              <Col class="mb-10" span="3">Ед.изм.</Col>
              <Col class="mb-10" span="3">Количество</Col>
              <Col class="mb-10" span="4">Цена</Col>
              <Col class="mb-10" span="3" style="text-align: right;">Всего</Col>
            </Row>
            <Divider style="margin: 0 0 10px 0;"></Divider>

            <Row
              class="desktop_table"
              v-for="(product, counter) in kit_composition.target_table"
              :key="product.id"
              :gutter="10"
              type="flex"
              justify="space-between"
              style="text-align: center;"
            >
              <Divider v-if="counter > 0" style="margin: 13px 0;"></Divider>
              <Col span="1">{{ counter + 1 }}</Col>
              <Col span="6" style="text-align: left;">{{ product.name }}</Col>
              <Col span="3" style="text-align: center;">{{
                product.unit ? product.unit : "-"
                }}</Col>
              <Col span="3" style="text-align: center;">
                {{ formatNumber(kit_composition.target_table[counter].count) }}
              </Col>
              <Col span="4">
                {{ formatNumber(kit_composition.target_table[counter].base_price) }}
              </Col>

              <Col span="3" style="text-align: right;"
              >{{ formatNumber(product.total_price) }} {{ currency }}</Col
              >
            </Row>


            <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
            <div class="mobile-table">
              <div class="card-container"
                   v-for="(product, counter) in kit_composition.target_table"
                   :key="product.id">

                <div>
                  <h2>{{ product.name }}</h2>
                  <p>Ед.изм.: {{product.unit ? product.unit : "-"}}</p>
                  <p>Кол-во: {{ formatNumber(kit_composition.target_table[counter].count) }}</p>
                  <p>Цена:  {{ formatNumber(kit_composition.target_table[counter].base_price) }}</p>
                  <h2>Всего: {{ formatNumber(product.total_price) }} {{ currency }}</h2>
                </div>

              </div>

            </div>

            <!-- TOTAL ROWS -->
            <div style="padding-top: 30px">
              <!--TOTAL SUM-->
              <Row :gutter="32" class="total_row">
                <Col span="12">
                  <h3>Всего:</h3>
                </Col>
                <Col span="12" style="text-align: right;">
                  <h3>
                    {{ formatNumber(total_sum) }} {{ currency }}
                  </h3>
                </Col>
              </Row>
            </div>

            <!-- DESCRIPTION FORM-->
            <Form :model="formData" style="margin-top: 20px; padding: 5px">
               <!--DESCRIPTION -->
              <FormItem>
                <Input
                  type="textarea"
                  v-model="formData.description"
                  :rows="4"
                  :placeholder="schema.description.label"
                />
              </FormItem>
            </Form>

          </div>
        </div>

        <Button
          style="display: inline-block;"
          type="success"
          @click="save"
          :disabled="disabled_save_button"
        >Сохранить
        </Button>
      </Col>
    </Row>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { order_type_labels } from "./order_type_list.js";
import { base_url } from "../../http.js";
import { formatNumber } from "../../base/base_func.js";
import { TYPE_CHANGES_IN } from './const.js'
import {BASE_PRICE, PURCHASE_PRICE} from "./const";

const CATALOG_TYPE_PRODUCT = 'PRODUCT';

export default {
  name: "productOrderFormChangeIn",
  data() {
    return {
      PRICE_ATTR: PURCHASE_PRICE,
      base_view_url: base_url + "/product_order/changes_in/",
      action: "create",
      id: "",
      loading: true,

      // Объект, отправляемый в бэк
      formData: {
        type: TYPE_CHANGES_IN,
        number: "",
        applied: true,
        order_date: new Date(),
        recipient: {
          type: "customer",
          id: ""
        },
        positions: [],
      },

      // Вспомогательный объект для хранения промежуточной информации о комплекте
      kit_composition: {
        search_value: "",
        source_table: {
          columns: [
            {
              key: "name",
              className: "kit_source_table_column",
              render: (h, params) => {
                return h("div", [
                  h("div", {}, params.row.name),
                  h(
                    "span",
                    {
                      style: { color: "#a4a4a4" }
                    },
                    formatNumber(params.row[this.PRICE_ATTR]) + " " + this.currency
                  )
                ]);
              }
            }
          ],
          data: [],
          total_records: 0,
          last_draw: 0,
          loading: false,
          current_page: 1,
          limit: 15
        },
        target_table: []
      },
      order_type_labels: order_type_labels,

      formSelectOptions: {
        store: [],
      },

      //currency: localStorage.getItem("currency"),

      validForm: false,
      isChanged: false,
      formDataRules: {
        // "sender.id": [
        //   { required: true, message: 'Пожалуйста, выберите отправителя', trigger: 'change', type:"number"}
        // ],
        "recipient.id": [
          { required: true, message: 'Пожалуйста, выберите получателя', trigger: 'change' }
        ],
      }
    };
  },
  asyncComputed: {
    schema: {
      get() {
        return this.$http.options(this.base_view_url).then(response => {
          return response.data.actions.POST;
        });
      }
    }
  },
  computed: {
    applied_label() {
      return this.formData.applied
        ? "Документ проведен"
        : "Документ не проведен";
    },

    // Итоговые цифры по заказу
    total_sum() {
      let sum = 0;
      for (let item of this.kit_composition.target_table) {
        sum += item.total_price;
      }
      return sum;
    },
    currency() {
      return this.$store.state.currency;
    },
    disabled_save_button(){
      if (this.action === 'create') {
        return this.kit_composition.target_table.length === 0 || !this.validForm;
      } else if (this.action === 'edit') {
        return !this.isChanged;
      }
    },
    recipient_label () {
      return 'Магазин';
    },
  },
  methods: {
    // Получение спсика товаров для формирования заказа
    fetchProductsForKit(filtered = false) {
      const url = base_url + "/catalog/products/";
      this.kit_composition.source_table.loading = true;
      this.kit_composition.source_table.last_draw++;

      let params = {
        format: "table",
        type: CATALOG_TYPE_PRODUCT,
        draw: this.kit_composition.source_table.last_draw,
        offset:
          this.kit_composition.source_table.limit *
            this.kit_composition.source_table.current_page -
          this.kit_composition.source_table.limit,
        limit: this.kit_composition.source_table.limit,
        search: this.kit_composition.search_value
      };

      this.$http
        .get(url, { params: params })
        .then(result => {
          if (
            result.data.draw === this.kit_composition.source_table.last_draw
          ) {
            if (filtered) {
              this.kit_composition.source_table.data = result.data.results;
            } else {
              for (let product of result.data.results) {
                this.kit_composition.source_table.data.push(product);
              }
            }

            this.kit_composition.source_table.total_records = result.data.count;
          }
        })
        .finally(() => {
          this.kit_composition.source_table.loading = false;
        });
    },

    // Добавление товрара в заказ
    addToKitTargetTable(data, index) {
      for (const [
        counter,
        item
      ] of this.kit_composition.target_table.entries()) {
        if (item.id === data.id) {
          this.kit_composition.target_table[counter].count++;

          let count = this.kit_composition.target_table[counter].count;

          // Скидку учитываем только при продаже и возврате продажи
          let discount = this.PRICE_ATTR === BASE_PRICE ? data.discount : 0;
          this.kit_composition.target_table[counter].total_price =
            parseFloat((data[this.PRICE_ATTR] * count -
            (data[this.PRICE_ATTR] * count * discount) / 100).toFixed(2));

          return;
        }
      }

      let number_inc = this.kit_composition.target_table.length + 1;
      // Скидку учитываем только при продаже и возврате продажи
      let discount = this.PRICE_ATTR === BASE_PRICE ? data.discount : 0;
      let price = parseFloat((data[this.PRICE_ATTR] - (data[this.PRICE_ATTR] * discount) / 100).toFixed(2));

      this.kit_composition.target_table.push({
        number_inc: number_inc,
        id: data.id,
        name: data.name,
        code: data.code,
        unit: data.unit,
        discount: discount,
        base_price: data[this.PRICE_ATTR],
        count: 1,
        total_price: price
      });

      this.fetchProductRest(data.id);
    },

    // Удаление товара из целеыой таблицы (КОМПЛЕКТ)
    deleteFromKitTargetTable(id) {
      for (const [
        counter,
        item
      ] of this.kit_composition.target_table.entries()) {
        if (item.id === id) {
          this.kit_composition.target_table.splice(counter, 1);
          return;
        }
      }
    },

    // Измнение кол-ва, цены по товару
    changeCountTargetTable(count, row_count) {
      this.kit_composition.target_table[row_count].count = count;
      this.changeTotalPriceTargetTable(row_count);
    },
    changePriceTargetTable(price, row_count) {
      this.kit_composition.target_table[row_count].base_price = price;
      this.changeTotalPriceTargetTable(row_count);
    },

    // Измнение полной цены товара (при измнении любого из парамтров товара)
    changeTotalPriceTargetTable(row_count) {
      let row = this.kit_composition.target_table[row_count];

      let count = row.count;
      let base_price = row.base_price;
      let discount = row.discount;

      this.kit_composition.target_table[row_count].total_price =
        parseFloat((base_price * count - (base_price * count * discount) / 100).toFixed(2));
    },

    getStores() {
      const url = base_url + "/options/stores/";
      this.$http
        .get(url)
        .then(result => {
          this.formSelectOptions.store = result.data.results;
        })
    },

    handleDataBeforeSave(formData){
      let data = formData;
      data.positions = [];
      for (let item of this.kit_composition.target_table) {
        data.positions.push({
          product: item.id,
          name: item.name,
          code: item.code,
          amount: item.count.toFixed(3),
          base_price: item.base_price.toFixed(2),
          discount: item.discount.toFixed(2),
          total_price: item.total_price.toFixed(2)
        });
      }

      // formData.money_orders.forEach((item, idx)=> {
      //   data.money_orders[idx] = {
      //     applied: item.applied,
      //     account: item.account,
      //     sum: item.sum.toFixed(2),
      //     date: item.date
      //   };
      // });

      data.total_sum = this.total_sum.toFixed(2);
      // data.paid_sum = this.paid_sum.toFixed(2);
      // data.total_discount = this.total_discount.toFixed(2);
      // data.total_discount_sum = this.total_discount_sum.toFixed(2);

      return data
    },

    save() {
      let http_method = "put";
      let url = `${this.base_view_url}${this.id}/`;

      if (this.action === "create") {
        http_method = "post";
        url = this.base_view_url;
      }

      let data = this.handleDataBeforeSave(this.formData);

      this.loading = true;
      this.$http[http_method](url, data)
        .then(response => {
          this.$Message.success("Успешно сохранено");
          this.$router.push({
            name: "product_order_detail",
            params: { id: response.data.id }
          });
          // this.showDetail(response.data.id);
          // if (this.action === "create") {
          //   this.$emit("change", response.data.id);
          // }
          // this.$emit("reload_table");
        })
              .finally(() => {
                this.loading = false;
              });
    },

    formatNumber(number) {
      return formatNumber(number);
    },

    setOrderDate(date_str, date2) {
      this.formData.order_date = date_str;
    },

    validateForm() {
      this.$refs.formData.validate((valid) => {
        this.validForm = valid;
      });
    },

    fetchInitialData() {
      this.$http
        .get(this.base_view_url + this.id)
        .then(response => {
          this.formData = response.data;

          if (this.formData.state) {
            this.is_order = true;
          }
          for (let field in this.formData) {
            if (field === 'positions') {
              this.formData[field] = response.data[field];

              // Заполняем времменую таблицу выбранных позицый для корректного редактирования
              for (const item of this.formData[field]) {
                let number_inc = this.kit_composition.target_table.length + 1;
                this.kit_composition.target_table.push({
                  number_inc: number_inc,
                  id: item.id,
                  name: item.name,
                  code: item.code,
                  // unit: response.data[field].unit,
                  unit: item.unit,
                  discount: item.discount,
                  base_price: item.base_price,
                  count: item.amount,
                  total_price: item.total_price
                });
              }

            } else {
              this.formData[field] = response.data[field];
            }
          }

          // Добавляем вотчеры на поля (для корректной работы добавляем после заполнекния формы)
          this.$watch("formData.state", function() {
            this.isChanged = true;
          });
          this.$watch("formData.order_date", function() {
            this.isChanged = true;
          });
          this.$watch("formData.applied", function() {
            this.isChanged = true;
          });
          this.$watch("formData.description", function() {
            this.isChanged = true;
          });
          // this.fetchSchema();
        })
              .finally(() => {
                this.loading = false;
              });
    },
  },

  // Поиск товара для набора (КОМПЛЕКТ)
  watch: {
    "kit_composition.search_value": function() {
      this.kit_composition.source_table.current_page = 1;
      this.fetchProductsForKit(true);
    },
    "kit_composition.source_table.current_page": function() {
      this.fetchProductsForKit();
    },
    // total_sum: function(newVal) {
    //   this.formData.money_orders[0].sum = newVal;
    // },

    "formData.recipient.id": function(to, from) {
      this.validateForm();
      // this.isChanged = true;
    },
  },

  mounted() {
    switch (this.$route.name) {
      case "product_order_change_in_create":
        this.action = 'create';
        this.fetchProductsForKit();
        break;
      case "product_order_change_in_edit":
        this.action = 'edit';
        this.id = this.$route.params.id;
        this.fetchInitialData();
        break;
    }
    this.getStores();
    this.loading = false;
  }
};
</script>

<style scoped>
.form__order_number {
  width: 100px;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-style: dashed;
  border-bottom-width: 2px;
}
.total_row {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px
}


.no-select {
  text-align: center;
  font-size: 28px;
  color: rgba(191,191,191,.87);
  margin-top: 20px;
  margin-bottom: 20px;
}

.card-container__one-col-table {
  padding: 10px 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.switch-custom span.ivu-switch {
  margin-left: 0;
}



@media screen and (max-width: 1500px) {
  .total_row {
    font-size: 14px
  }

  .no-select {
    font-size: 20px;
  }
}

@media screen and (max-width: 991px) {
  .card-container__one-col-table {
    padding: 0;
    box-shadow: none;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    /*margin-bottom: 30px;*/
  }

  .mobile-table .card-container {
    margin: 0 5px 10px 5px;
  }
  .mobile-table .card-container p {
    margin-bottom: 10px;
  }

  .target_table .ivu-input-number {
    padding: 2px 5px;
    font-size: 12px;
    margin-left: 10px;
    max-width: 80px;
    width: auto;
  }

  .no-select {
    margin-top: 50px;
    margin-bottom: 50px;
  }


}
</style>



<style>
.kit_source_table_column {
  cursor: pointer;
}
.ls_source_table {
  height: 699px;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #dcdee2 !important;
}


@media screen and (max-width: 991px) {
  .ivu-input-number-handler-wrap {
    display: none;
  }

  .mobile-table .ivu-input-number-input-wrap {
    height: auto;
  }

  .mobile-table .ivu-input-number-input {
    height: auto;
    line-height: 1;
  }
}

@media screen and (max-width: 767px) {
  .ivu-date-picker {
    width: 100%;
  }
  .datepicker_input {
    width: 100%;
  }
}

@media screen and (min-width: 768px) {
  .ivu-col-span-md-0 {
    display: block;
    width: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderFormChangeIn.vue